import axiosInstance from "./axiosInstance";

import type { CreateMeetingProps } from "../types";

export async function createMeeting({
  startTime,
  userTimezone,
  hostTimezone,
  userName,
  userEmail,
}: CreateMeetingProps) {
  try {
    const { data } = await axiosInstance.post("/createMeeting", {
      startTime,
      userTimezone,
      hostTimezone,
      userName,
      userEmail,
    });

    return data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Error creating meeting");
  }
}
